import { Star } from 'lucide-react';
import React from 'react';

interface StoryStarRatingProps {
  rating: number;
  className?: string;
}

/** Renders 1–5 stars with half-star support (e.g. 4.5). */
const StoryStarRating: React.FC<StoryStarRatingProps> = ({ rating, className = '' }) => {
  const clamped = Math.min(5, Math.max(0, rating));
  const label = `${clamped % 1 === 0 ? clamped.toFixed(0) : clamped.toFixed(1)} out of 5 stars`;

  return (
    <div className={`home-social-proof__stars ${className}`.trim()} aria-label={label}>
      <div className="home-social-proof__stars-row" aria-hidden>
        {Array.from({ length: 5 }, (_, i) => {
          const starIndex = i + 1;
          const filled = clamped >= starIndex;
          const half = !filled && clamped >= starIndex - 0.5;

          return (
            <span key={starIndex} className="home-social-proof__star-slot">
              <Star className="home-social-proof__star home-social-proof__star--empty" />
              {(filled || half) && (
                <span
                  className="home-social-proof__star-fill"
                  style={{ width: filled ? '100%' : '50%' }}
                >
                  <Star className="home-social-proof__star home-social-proof__star--filled" />
                </span>
              )}
            </span>
          );
        })}
      </div>
      <span className="home-social-proof__stars-value t-num">
        {clamped % 1 === 0 ? clamped.toFixed(0) : clamped.toFixed(1)}
      </span>
    </div>
  );
};

export default StoryStarRating;
